export const gicMiniModalDiscoverabilityPreferenceKey =
	'jira.user.gic.mini.modal.discoverability' as const;
